<template>
    <div>

        <div v-if="isPhone" class="mobile">

            <div>
                <!--banner-->
                <header class="banner">
                    <img src="../../assets/img/web-front-end/banner1.jpg" style="height:100%;width: 100%;" alt="">
                </header>

                <div class="introduce-container">
                    <section class="what-is-web-front-end-section">
                        <div class="section-title">
                            <div>
                                <img src="../../assets/img/web-front-end/what-web-front-end-title.png">
                                <span>什么是前端全栈工程师？</span>
                            </div>
                        </div>
                        <div class="web-front-end-desc-box">
                            <!--                        飞入动画-->
                            <transition name="what-is-web-right">
                                <div v-if="leftImg" class="content">
                                    <h3>什么是web、<span>前端</span>？</h3>
                                    <p>
                                        <span>Web</span>为你在浏览器、APP、应用程序等设备上提供直观界面，这些界面展现以及用户交互就是 <span>前端</span>。
                                    </p>
                                    <p>
                                        从2016年到2017年，web前端岗位从之前的爆发式增长变为平稳的发展。同时，企业不再满足只会HTM，CSS这些简单的页面搭建，而是希望前端成
                                        为更健壮，更体系化的东西。所以，Angular与Vue这类JS框架开始火了起来，在一年的时间里可以发布多个版本，这是其他语言无法达到的。目前
                                        各大IT企业已经开始从传统的web前端开发招聘向web全栈开发方向转变。2017年，web全栈开发工程师更是非常匮乏。
                                    </p>
                                </div>
                            </transition>
                        </div>
                        <div class="web-front-end-desc-bottom-box">
                            <p>
                                <span>全栈工程师</span>是指掌握<br>
                                多种技能，并能利用多种技能独立完成产品的人
                            </p>
                        </div>
                    </section>

                    <section class="web-front-end-future-section">
                        <div class="section-title">
                            <transition name="what-is-web-advantage">
                                <div v-if="webFuture">
                                    <img src="../../assets/img/web-front-end/web-front-end-future-title.png" alt="图片">
                                    <span>web前端全栈工程师的前景就业？</span>
                                </div>
                            </transition>
                        </div>
                        <div class="section-content-box">
                            <div class="section-content">
                                <div class="content-text">
                                    <h3>1、工作岗位人才稀缺</h3>
                                    <p>
                                        目前HTML5工程师日均岗位缺口超50000<br>
                                        随着互联网+深入发展<br>
                                        作为唯一前端展示技术<br>
                                        预计HTML5人才缺口将翻倍增长<br>
                                    </p>
                                </div>
                                <!--                            <img [src]="staticImgPre+'/zhexian.png'" alt="图片">-->
                                <img src="../../assets/img/web-front-end/zhexian.png" alt="">
                            </div>
                            <div class="section-content">
                                <!--                            <img [src]="staticImgPre+'/gongzi.png'" alt="图片">-->
                                <img src="../../assets/img/web-front-end/gongzi.png" alt="">

                                <div class="content-text" style="margin-left: 60px">
                                    <h3>2、岗位工资逐年提升</h3>
                                    <p>
                                        2017年前端工程师平均薪资高达17240元
                                        不仅如此，前端作为互联网时代直接触达用户的窗口<br>
                                        前端人员的薪资更是一年高过一年
                                    </p>
                                </div>

                            </div>
                            <div class="section-content content-bottom ">
                                <p> 现在，Web前端工程师在Web中占有了一席之地。随着多设备、浏览器和Web标准的演变革命，Web前端正在成为兼顾逻辑、性能、交互、体验的综合性岗位。</p>
                            </div>
                        </div>
                    </section>

                    <section class="tledu-web-front-end-advantage-section">
                        <div class="section-title">
                            <transition name="what-is-web-advantage">
                                <div v-if="advantage">
                                    <img src="../../assets/img/web-front-end/tledu-web-front-end-advantage.png"
                                         alt="图片">
                                    <span>天亮教育web前端全栈教学优势！</span>
                                </div>
                            </transition>

                        </div>
                        <div class="section-content-box">
                            <div class="section-content">
                                <div class="content-text">
                                    <h3>1、师资力量雄厚</h3>
                                    <p>
                                        讲师均为一线互联网公司工作经验或对口专业方向授课4年起，项目或授课实战经验丰富。
                                    </p>
                                </div>
                                <img src="../../assets/img/web-front-end/shizi.png" alt="图片">
                            </div>
                            <div class="section-content">
                                <img src="../../assets/img/web-front-end/hezuo.png" alt="">

                                <div class="content-text">
                                    <h3>2、学习就业有保障</h3>
                                    <p>
                                        多家兄弟公司直接录用<br>
                                        北上广深一线互联网公司均有优质内推资源直达面试<br>
                                        社群资源强大，直招直录<br>
                                        毕业学员正式工作平均月薪10K，实习工作平均月薪4K
                                    </p>
                                </div>

                            </div>
                            <div class="section-content content-bottom">
                                <h3>3、免费试学，与名师零距离接触</h3>
                                <p>
                                    零基础，一周免费试学, 感受实际上课环境，与名师进行零距离面对面交流。
                                </p>
                            </div>
                        </div>
                    </section>
                </div>

                <footer class="footer">
                    <p>精细的课程，完整的教学体系，让学员学的放心，找到高薪工作！</p>
                </footer>
            </div>
            <div style="height: 50px"></div>

            <course-direction-pay class="<course-direction-pay-phone" :directionId='directionId'/>

        </div>

        <div v-else class="course-direction-web">
            <!--            <header>-->
            <!--                <course-direction-pay :directionId='directionId'/>-->
            <!--            </header>-->
            <div>
                <!--banner-->
                <header class="banner">
                    <img src="../../assets/img/web-front-end/banner1.jpg" style="height:100%;width: 100%;" alt="">
                </header>


                <div class="introduce-container">
                    <section class="what-is-web-front-end-section ">
                        <div style="position: relative;height: 140px;background: #021b75">
                            <transition appear name="what-is-web-left">
                                <course-direction-pay :directionId='directionId'/>
                            </transition>
                        </div>
                        <div class="section-title">
                            <!--                        飞入动画-->

                            <transition appear name="what-is-web-right">
                                <div>
                                    <img src="../../assets/img/web-front-end/what-web-front-end-title.png">
                                    <span>什么是前端全栈工程师？</span>
                                </div>
                            </transition>

                        </div>


                        <div class="web-front-end-desc-box">
                            <!--                        飞入动画-->
                            <transition appear name="what-is-web-left">
                                <img src="../../assets/img/web-front-end/boy.png">
                            </transition>

                            <!--                        <div class="content" [@openCloseRight]="height800?'open':'close'">-->
                            <transition appear name="what-is-web-right">
                                <div class="content">
                                    <h3>什么是web、<span>前端</span>？</h3>
                                    <p>
                                        <span>Web</span>为你在浏览器、APP、应用程序等设备上提供直观界面，这些界面展现以及用户交互就是 <span>前端</span>。
                                    </p>
                                    <p>
                                        从2016年到2017年，web前端岗位从之前的爆发式增长变为平稳的发展。同时，企业不再满足只会HTM，CSS这些简单的页面搭建，而是希望前端成
                                        为更健壮，更体系化的东西。所以，Angular与Vue这类JS框架开始火了起来，在一年的时间里可以发布多个版本，这是其他语言无法达到的。目前
                                        各大IT企业已经开始从传统的web前端开发招聘向web全栈开发方向转变。2017年，web全栈开发工程师更是非常匮乏。
                                    </p>
                                </div>
                            </transition>

                        </div>
                        <div class="web-front-end-desc-bottom-box">
                            <p>
                                <span>全栈工程师</span>是指掌握<br>
                                多种技能，并能利用多种技能独立完成产品的人
                            </p>
                        </div>
                    </section>

                    <section class="web-front-end-future-section">
                        <div class="section-title">

                            <transition name="what-is-web-advantage">
                                <div v-if="webFuture">
                                    <img src="../../assets/img/web-front-end/web-front-end-future-title.png" alt="图片">
                                    <span>web前端全栈工程师的前景就业？</span>
                                </div>
                            </transition>

                        </div>
                        <div class="section-content-box">
                            <div class="section-content">
                                <div class="content-text">
                                    <h3>1、工作岗位人才稀缺</h3>
                                    <p>
                                        目前HTML5工程师日均岗位缺口超50000<br>
                                        随着互联网+深入发展<br>
                                        作为唯一前端展示技术<br>
                                        预计HTML5人才缺口将翻倍增长<br>
                                    </p>
                                </div>
                                <img src="../../assets/img/web-front-end/zhexian.png" alt="">
                            </div>
                            <div class="section-content">
                                <img src="../../assets/img/web-front-end/gongzi.png" alt="">

                                <div class="content-text" style="margin-left: 60px">
                                    <h3>2、岗位工资逐年提升</h3>
                                    <p>
                                        2017年前端工程师平均薪资高达17240元
                                        不仅如此，前端作为互联网时代直接触达用户的窗口<br>
                                        前端人员的薪资更是一年高过一年
                                    </p>
                                </div>

                            </div>
                            <div class="section-content content-bottom ">
                                <p> 现在，Web前端工程师在Web中占有了一席之地。随着多设备、浏览器和Web标准的演变革命，Web前端正在成为兼顾逻辑、性能、交互、体验的综合性岗位。</p>
                            </div>
                        </div>
                    </section>

                    <section class="tledu-web-front-end-advantage-section">
                        <div class="section-title">
                            <!--                        动画-->
                            <transition name="what-is-web-advantage">
                                <div v-if="advantage">
                                    <img src="../../assets/img/web-front-end/tledu-web-front-end-advantage.png"
                                         alt="图片">
                                    <span>天亮教育web前端全栈教学优势！</span>
                                </div>
                            </transition>

                        </div>
                        <div class="section-content-box">
                            <div class="section-content">
                                <div class="content-text">
                                    <h3>1、师资力量雄厚</h3>
                                    <p>
                                        讲师均为一线互联网公司工作经验或对口专业方向授课4年起，项目或授课实战经验丰富。
                                    </p>
                                </div>
                                <img src="../../assets/img/web-front-end/shizi.png" alt="图片">
                            </div>
                            <div class="section-content">
                                <img src="../../assets/img/web-front-end/hezuo.png" alt="">

                                <div class="content-text">
                                    <h3>2、学习就业有保障</h3>
                                    <p>
                                        多家兄弟公司直接录用<br>
                                        北上广深一线互联网公司均有优质内推资源直达面试<br>
                                        社群资源强大，直招直录<br>
                                        毕业学员正式工作平均月薪10K，实习工作平均月薪4K
                                    </p>
                                </div>

                            </div>
                            <div class="section-content content-bottom">
                                <h3>3、免费试学，与名师零距离接触</h3>
                                <p>
                                    零基础，一周免费试学, 感受实际上课环境，与名师进行零距离面对面交流。
                                </p>
                            </div>
                        </div>
                    </section>
                </div>

                <footer class="footer">
                    <p>精细的课程，完整的教学体系，让学员学的放心，找到高薪工作！</p>
                    <button type="button" class="button" @click="toTiangLiang"><span
                            style="font-size: 22px;color: #1ec5ef">查看课程大纲</span>
                    </button>
                </footer>
            </div>

        </div>


    </div>
</template>

<script>
    import {learningDirectionDetail} from "@api/courseDirection-api"
    import {showError, showSuccessMsg} from "@utils/msg";
    import CourseDirectionPay from "@components/courseDirection/CourseDirectionPay"
    import common from "../../mixin/common";

    export default {
        name: "CourseDirectionWeb",
        components: {
            CourseDirectionPay
        },
        mixins: [common],
        data() {
            return {
                directionId: "",
                learningDirection: {},
                isPhone: false,
                //控制左侧图片动画
                leftImg: false,
                //控制web优势入场动画
                advantage: false,
                //web前景就业
                webFuture: false,
                // 监听滚动
                scroll: "",
            }
        },
        created() {
            if (this.isMobile) {
                this.isPhone = true
            }

            this.directionId = this.$route.query.directionId
            learningDirectionDetail(this.directionId).then((res) => {
                if (res.code === 0) {
                    if (res.canStudyDirection) {
                        //    跳转到学院专属课程详情
                        // this.$message.success("您已购买该方向课程，快开始学习吧！");
                    } else {
                        //    跳转到返回的url
                        showSuccessMsg("您未购买该方向课程，先来了解下课程体系吧！");
                        this.learningDirection = res.learningDirection
                    }
                } else {
                    showError("获取学习方向出错", res.msg)
                }
            })
        },
        methods: {
            toTiangLiang() {
                window.open("http://myhope365.com/course/web-front-end")
            },
            handleScroll() {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (this.scroll > 0) {
                    this.leftImg = true
                }
                if (this.scroll > 400) {
                    this.webFuture = true
                }
                if (this.scroll > 1370) {
                    this.advantage = true
                }
            }

        },
        mounted() {
            //    监听滚轮事件
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        },

    }
</script>

<style scoped lang="less">
    @import "../../styles/direction";

    .phone {
        display: none;
    }

    .paid {
        display: block;
    }

    /*响应式*/
    @import '../../styles/variable.less';

    @media screen and (max-width: @screen-lg) {
        .phone {
            display: block;
        }

        .paid {
            display: none;
        }
    }
    /* ***************************************************************************/
    /*// 什么是web前端*/
    .course-direction-web {
        .what-is-web-front-end-section {
            .web-front-end-desc-box {
                display: flex;
                justify-content: center;
                align-items: flex-end;
                margin-top: 40px;
                margin-bottom: 30px;

                img {
                    margin-right: -20px;
                    z-index: 2;
                }

                .content {
                    border-top: 1px solid;
                    border-left: 5px solid;
                    border-right: 1px solid;
                    border-bottom: 5px solid;
                    border-radius: 40px;
                    padding: 25px 40px;
                    border-color: #c33a3a;
                    width: 700px;

                    h3 {
                        color: #c33a3a;
                        font-size: 20px;
                        font-weight: 400;

                        span {
                            font-size: 22px;
                            font-weight: 500;
                        }
                    }
                }
            }

            .web-front-end-desc-bottom-box {
                text-align: center;

                p {
                    width: 800px;
                    display: inline-block;
                    text-align: center;
                    text-indent: 0;
                    font-size: 24px;
                    background-color: #4589e4;
                    border-radius: 15px;
                    color: white;
                    padding: 15px;
                    margin-bottom: 30px;
                    font-weight: 300;

                    span {
                        font-size: 28px;
                        font-weight: 400;
                    }
                }
            }
        }

        /*// web前端全栈工程师的就业前景*/

        .web-front-end-future-section {
            background-color: #0e0823;
            padding-bottom: 30px;

            .section-title {
                background-color: #8f1b70;
            }

            .section-content-box {
                .section-content {
                    border: 1px solid #df37b2;
                }

                .content-bottom {
                    border: none;
                }
            }
        }

        /*// 天亮web前端全栈的优势*/

        .tledu-web-front-end-advantage-section {
            background-color: #391e0b;
            padding-bottom: 30px;

            .section-title {
                background-color: #ff6900;
            }

            .section-content-box {
                .section-content {
                    padding: 20px 55px;
                    justify-content: space-between;

                    .content-text {
                        width: 450px;
                    }

                    h3 {
                        color: #ff6900;
                    }

                    p {
                        color: white;
                    }
                }

                .content-bottom {
                    border: none;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    text-align: center;

                    p {
                        text-indent: 0;
                    }
                }
            }
        }

        /*// footer*/

        .footer {
            text-align: center;
            padding: 20px;
            background-color: #0e0824;

            p {
                text-align: center;
                margin-bottom: 15px;
                color: #df37b2;
            }

            .button {
                width: 220px;
                height: 52px;
                border-radius: 16px;
                background-color: #101029;
                border: 1px solid #1ec5ef;
            }

            .button:hover {
                cursor: pointer;
            }
        }

        /*// 通用部分*/

        .section-title {
            background-color: #1256b2;
            background-color: #021b75;
            height: 80px;
            text-align: center;
            padding: 5px 0;
            color: white;
            font-size: 45px;
            display: flex;
            justify-content: center;


            img {
                height: 100%;
                margin-right: 10px;
            }
        }

        .section-content-box {
            .section-content {
                width: 900px;
                margin: 0 auto;
                margin-top: 30px;
                padding: 35px 55px;
                display: flex;
                text-align: left;
                justify-content: space-around;

                h3 {
                    font-size: 35px;
                    color: #33e7f8;
                    letter-spacing: 5px;
                }

                p {
                    color: #df37b2;
                    line-height: 40px;
                    font-size: 24px;
                    text-indent: 0;
                }

                img {
                    width: 250px;
                    height: 250px;
                }
            }

            .content-bottom {
                border: none;
                padding: 0;

                p {
                    text-indent: 35px;
                    color: white;
                }
            }
        }

        img {
            max-width: 100%;
            max-height: 100%;
        }

        p {
            margin: 0;
            font-size: 18px;
            letter-spacing: 2px;
            text-align: justify;
            text-indent: 25px;

            span {
                font-size: 20px;
                color: #c33a3a;
            }
        }

        /deep/ .to-pay {
            top: 0px;
        }

        /*//轮播图*/

        .banner {
            width: 100%;
        }
    }

    .what-is-web-left {
        overflow: hidden;
    }

    .what-is-web-left-enter-active {
        transition: all 1.5s ease;
    }

    .what-is-web-left-enter, .what-is-web-left-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }

    .what-is-web-left-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .what-is-web-right-enter-active {
        transition: all 1.5s ease;
    }

    .what-is-web-right-enter, .what-is-web-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    .what-is-web-right-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    what-is-web-advantage-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .what-is-web-advantage-enter-active {
        transition: all 1.5s ease;
    }

    .what-is-web-advantage-enter, .what-is-web-advantage-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }

    /*    手机端样式 */
    .mobile {
        .top-img-title-box {
            background-color: #101029;
        }

        //轮播图
        .banner {
            width: 100%;
        }

        // 什么是web前端
        .what-is-web-front-end-section {
            .web-front-end-desc-box {
                display: flex;
                justify-content: center;
                align-items: flex-end;
                flex-direction: column;
                margin: 2rem 1.5rem;

                img {
                    margin-right: -20px;
                    z-index: 2;
                }

                .content {
                    border-top: 1px solid;
                    border-left: 5px solid;
                    border-right: 1px solid;
                    border-bottom: 5px solid;
                    border-radius: 2rem;
                    padding: 1.2rem 2rem;
                    border-color: #c33a3a;

                    h3 {
                        color: #c33a3a;
                        font-size: 1rem;
                        font-weight: 400;

                        span {
                            font-size: 1.2rem;
                            font-weight: 500;
                        }
                    }
                }
            }

            .web-front-end-desc-bottom-box {
                text-align: center;

                p {
                    display: inline-block;
                    text-align: center;
                    text-indent: 0;
                    font-size: 1rem;
                    background-color: #4589e4;
                    border-radius: .7rem;
                    color: white;
                    padding: .7rem;
                    margin-bottom: 1.5rem;
                    font-weight: 300;

                    span {
                        font-size: 1.2rem;
                        font-weight: 400;
                    }
                }
            }
        }

        // web前端全栈工程师的就业前景
        .web-front-end-future-section {
            background-color: #0e0823;
            padding-bottom: 1.5rem;

            .section-title {
                background-color: #8f1b70;
            }

            .section-content-box {
                margin: 0 1rem;

                .section-content {
                    flex-direction: column;
                    border: 1px solid #df37b2;
                }

                .content-bottom {
                    border: none;
                }
            }
        }

        // 天亮web前端全栈的优势
        .tledu-web-front-end-advantage-section {
            background-color: #391e0b;
            padding-bottom: 1.5rem;

            .section-title {
                background-color: #ff6900;
            }

            .section-content-box {
                .section-content {
                    padding: 1rem;
                    flex-direction: column;

                    .content-text {
                    }

                    h3 {
                        color: #ff6900;
                    }

                    p {
                        color: white;
                    }
                }

                .content-bottom {
                    border: none;
                    display: flex;
                    flex-direction: column;

                    p {
                        text-indent: 0;
                    }
                }
            }
        }

        // footer
        .footer {
            text-align: center;
            padding: 1rem;
            background-color: #0e0824;

            p {
                text-align: center;
                margin-bottom: .7rem;
                color: #df37b2;
            }

            .button {
                width: 220px;
                height: 52px;
                border-radius: 16px;
                background-color: #101029;
                border: 1px solid #1ec5ef;
            }

            .button:hover {
                cursor: pointer;
            }
        }

        // 通用部分
        .section-title {
            background-color: #1256b2;
            height: 3rem;
            text-align: center;
            padding: 0.2rem 0;
            color: white;
            font-size: 1.3rem;
            line-height: 2.5rem;
            display: flex;
            justify-content: center;
            overflow: hidden;

            img {
                height: 100%;
                margin-right: .4rem;
            }
        }

        .section-content-box {
            .section-content {
                //width: 900px;
                margin: 0 auto;
                margin-top: 1.5rem;
                padding: 1.5rem;
                display: flex;
                text-align: left;
                justify-content: space-around;

                h3 {
                    font-size: 1.2rem;
                    color: #33e7f8;
                    letter-spacing: 5px;
                }

                p {
                    color: #df37b2;
                    line-height: 1.5rem;
                    font-size: 1rem;
                    text-indent: 0;
                }

                img {
                    width: 80%;
                    margin: 0 auto;
                }
            }

            .content-bottom {
                border: none;
                padding: 0;

                p {
                    text-indent: 1.5rem;
                    color: white;
                }
            }
        }

        img {
            max-width: 100%;
            max-height: 100%;
        }

        p {
            margin: 0;
            letter-spacing: 2px;
            text-align: justify;
            text-indent: 1.5rem;

            span {
                font-size: 1rem;
                color: #c33a3a;
            }
        }
    }


</style>
